module.exports = __webpack_public_path__ + "392256051589d49b0be9a32fd81d9753.svg";